// src/helpers/paginateButtons.ts
var paginateButtons = (buttons, buttonsPerPage, specialButtons = 0, specialButtonsOnEveryPage = false) => {
  const pages = [];
  if (specialButtonsOnEveryPage) {
    buttonsPerPage -= specialButtons;
    specialButtons = 0;
  }
  let startingIndex = 0;
  let endingIndex = buttonsPerPage - specialButtons;
  while (startingIndex < buttons.length) {
    pages.push(buttons.slice(startingIndex, endingIndex));
    startingIndex = endingIndex;
    endingIndex += buttonsPerPage;
  }
  return pages;
};

export { paginateButtons };
